import './footer.scss';
import { contactDataState } from 'redux/slices/webSlice';
import { useSelector } from 'react-redux';
import IconPromise from '../IconPromise/IconPromise';
import { phoneFormater } from 'screens/atClient/contact/Contact';
import { menuFooterState } from 'redux/slices/routesSlice';
import { accentsTidy } from 'utils/utils';
import { useNavigate } from 'react-router-dom';
import UseSEO from 'hooks/useSEO/UseSEO';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';
// import { useLanguage } from 'context/languageContext';

import ayuntamiento from 'resources/icons/footer/ayuntamiento.png'; //Eliminar
//import emt from 'resources/icons/footer/emt.png'; //Eliminar
import EMTPalma from 'resources/icons/footer/logo_emt_1x.png'; //Eliminar
import proyecto from 'resources/icons/footer/proyecto.png'; //Eliminar
import gob from 'resources/icons/footer/gob.png'; //Eliminar
import union from 'resources/icons/footer/union.png'; //Eliminar

export default function Footer() {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const [generateUrl, generateTitleAndMeta, navigateStaticPage] = UseSEO();
  const contactDataSelector = useSelector(contactDataState);
  const footerMenuSelector = useSelector(menuFooterState);
  // const currentLanguage = useLanguage();

  const handleClick = (url, pageId, newId, title) => {
    if (url) {
      url && (url.includes('https://') || url.includes('http://'))
        ? window.open(url, '_blank')
        : navigate(generateUrl(url, 'SUB'));
    } else if (pageId) {
      // navigate(`${currentLanguage}/emt?pageId=${pageId}`);
      navigateStaticPage(pageId);
    } else if (newId) {
      navigate(`${generateUrl(RUTAS_GENERALES_MUL2.emtNewDetail)}${newId}/${accentsTidy(title)}`);
    }
    window.scroll({
      top: 0,
      left: 100,
      behavior: 'smooth',
    });
  };

  return (
    <footer>
      <div className='footer-main-img'>
        <div className='footer-main-img-box'>
          <img src={ayuntamiento} alt='ajuntament de Palma' />
          <img src={EMTPalma} alt='ajuntament de Palma' />
          <img src={proyecto} alt='ajuntament de Palma' />
          <img src={gob} alt='ajuntament de Palma' />
          <img src={union} alt='ajuntament de Palma' />
        </div>
      </div>


      <div className='footer-container'>
        <div className='footer-container-box'>
          {contactDataSelector?.twitterIconId && (
            <div className='social'>
              <a href={contactDataSelector?.facebookUrl} target='blank' className='social-icon'>
                <IconPromise idIcon={contactDataSelector?.facebookIconId} />
              </a>
              <a href={contactDataSelector?.twitterUrl} target='blank' className='social-icon'>
                <IconPromise idIcon={contactDataSelector?.twitterIconId} />
              </a>
              <a href={contactDataSelector?.instagramUrl} target='blank' className='social-icon'>
                <IconPromise idIcon={contactDataSelector?.instagramIconId} />
              </a>
              <span className='social-icon--text'>
                <span className='social-icon' style={{minWidth:'26px'}}>
                  <IconPromise idIcon={contactDataSelector?.emailIconId} />
                </span>
                <a href={`mailto:${contactDataSelector?.email}`}>{contactDataSelector?.email}</a>
              </span>
              <div className='social-icon--phones'>
                <span className='social-icon' style={{minWidth:'26px'}}>
                  <IconPromise idIcon={contactDataSelector?.phoneIconId} />
                </span>
                <div className='phone-box'>
                  <a href={`tel:${contactDataSelector?.phoneOne}`}>{` ${phoneFormater(
                    contactDataSelector?.phoneOne,
                  )}`}</a>
                  <span style={{margin:'0 2px'}}>/</span>
                  <a href={`tel:${contactDataSelector?.phoneTwo}`}>{` ${phoneFormater(
                    contactDataSelector?.phoneTwo,
                  )} `}</a>
                </div>
              </div>
            </div>
          )}

          {contactDataSelector?.twitterIconId && <hr />}

          <div className='footer-box'>
            <div className='menu'>
              <div className='main-menu'>
                {footerMenuSelector.map((item, j) => (
                  <div
                    className='menu-item-box'
                    key={`${item.name}-${j}`}
                  >
                    <strong className='menu-title'>{item.name}</strong>
                    <div className='menu-item'>
                      {item.child.map((opt, i) => (
                        <p
                          key={`${opt.id}-${i}`}
                          className='menu-label'
                          onClick={() => handleClick(opt.url, opt.pageId, opt.newsId, opt.name)}
                        >
                          {opt.name}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
